<template>
  <div
    v-if="$store.getters.userId != ''"
    class="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100 py-8 px-4"
  >
    <!-- Hero Section -->
    <div class="max-w-6xl mx-auto mb-6">
      <div class="text-center mb-6">
        <!-- <div class="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-r from-blue-500 to-purple-600 rounded-2xl mb-6 shadow-lg">
          <svg class="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"></path>
          </svg>
        </div> -->
        <h1
          class="text-5xl md:text-6xl font-extrabold text-gray-900 mb-4 tracking-tight"
        >
          የእኔ
          <span
            class="bg-gradient-to-r from-blue-600 via-purple-600 to-indigo-600 bg-clip-text text-transparent"
            >የኪራይ ልጥፎች</span
          >
        </h1>
        <p class="text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed">
          የእርስዎን የኪራይ ንብረቶች ያስተዳድሩ፣ ያሻሽሉ እና ያከራዩ
        </p>
      </div>
    </div>

    <!-- Form Container -->
    <div class="max-w-4xl mx-auto">
      <div class="bg-white rounded-3xl shadow-2xl overflow-hidden">
        <!-- Form Header -->
        <div class="bg-gradient-to-r from-blue-500 to-purple-600 px-6 py-6">
          <div class="justify-between flex items-center space-x-3">
            <div>
              <!-- <h2 class="text-2xl font-bold text-white ml-4">ye</h2> -->
              <p class="text-sm text-white mt-1">የሚከራይ ለመለጠፍ + ምልክቱን ይጫኑ</p>
            </div>
            <div
              @click="
                $router
                  .push({
                    name: 'home',
                  })
                  .catch((err) => {})
              "
              class="w-12 h-12 bg-white bg-opacity-20 rounded-xl flex items-center justify-center"
            >
              <svg
                class="w-6 h-6 text-white"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                ></path>
              </svg>
            </div>
          </div>
        </div>

        <!-- Form Content -->
        <div class="p-4 md:p-6">
          <!-- Enhanced Loading State -->
          <div
            v-if="loading"
            class="flex flex-col justify-center items-center h-64 space-y-4"
          >
            <div class="relative">
              <div
                class="w-16 h-16 border-4 border-blue-200 rounded-full animate-spin"
              ></div>
              <div
                class="absolute top-0 left-0 w-16 h-16 border-4 border-transparent border-t-blue-600 rounded-full animate-spin"
              ></div>
            </div>
            <div class="text-center">
              <h3 class="text-lg font-semibold text-gray-700 mb-2">
                Loading your rentals...
              </h3>
              <p class="text-gray-500">እባክዎን ትንሽ ይጠብቁ</p>
            </div>
          </div>
          <div
            v-else-if="!rentals || rentals.length === 0"
            class="p-10 text-center text-gray-600"
          >
            <div
              class="mx-auto w-12 h-12 mb-3 rounded-full bg-blue-50 flex items-center justify-center"
            >
              <svg
                class="w-6 h-6 text-blue-500"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z"
                />
              </svg>
            </div>
            <p class="text-lg font-semibold text-gray-800">ምንም ውጤት አልተገኘም</p>
            <p class="text-sm text-gray-500 mt-1">
              የ ኪራይ ልጥፍ የልዎትም እባክዎን + ምልክቱን በመጫን አዲስ የኪራይ ልጥፍ ይፍጠሩ።
            </p>
          </div>
          <!-- Enhanced Error State -->
          <div
            v-if="error"
            class="bg-red-50 border border-red-200 rounded-xl p-6 text-center"
          >
            <div class="flex justify-center mb-4">
              <div
                class="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center"
              >
                <svg
                  class="w-6 h-6 text-red-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
              </div>
            </div>
            <h3 class="text-lg font-semibold text-red-800 mb-2">
              Error Loading Rentals
            </h3>
            <p class="text-red-600 mb-4">{{ error.message }}</p>
            <button
              @click="fetchRentals"
              class="bg-red-600 text-white font-semibold py-2 px-4 rounded-lg hover:bg-red-700 transition-colors duration-200"
            >
              እባክዎን እንደገና ይሞክሩ
            </button>
          </div>
          <div class="grid gap-6 md:gap-8">
            <div
              v-for="(rental, i) in rentals"
              :key="rental.rent_id"
              class="group bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border border-gray-100 hover:border-blue-200"
            >
              <!-- Enhanced Media Gallery -->
              <div class="relative">
                <div
                  class="flex overflow-x-auto space-x-3 p-4 bg-gradient-to-r from-gray-50 to-blue-50"
                >
                  <!-- Images -->
                  <template v-for="(img, index) in rental.images.split(',')">
                    <div
                      v-if="img && img.trim() !== ''"
                      :key="'img-' + index"
                      class="flex-shrink-0 relative group"
                    >
                      <img
                        :src="img"
                        class="w-32 sm:w-32 md:w-32 h-20 sm:h-20 object-contain rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-200 bg-white"
                        alt="Rental image"
                      />
                      <div
                        class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-20 rounded-xl transition-all duration-200 flex items-center justify-center"
                      >
                        <svg
                          class="w-6 h-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0zM10 7v3m0 0v3m0-3h3m-3 0H7"
                          ></path>
                        </svg>
                      </div>
                    </div>
                  </template>
                  <!-- Videos -->
                  <template v-for="(vid, index) in rental.videos.split(',')">
                    <div
                      v-if="vid && vid.trim() !== ''"
                      :key="'vid-' + index"
                      class="flex-shrink-0 relative group"
                    >
                      <video
                        :src="vid"
                        class="w-32 sm:w-32 md:w-32 h-20 sm:h-20 object-contain rounded-lg overflow-hidden shadow-md hover:shadow-lg transition-all duration-200 bg-white"
                        controls
                      ></video>
                      <div
                        class="absolute top-2 right-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full font-medium"
                      >
                        Video
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <!-- Rental Details -->
              <div class="p-6">
                <div class="mb-4">
                  <h3 class="text-2xl font-bold text-gray-900 mb-2">
                    {{ i + 1 }}. {{ rental.title }}
                  </h3>
                  <!-- <div class="flex items-center space-x-2">
                    <span
                      class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-blue-100 text-blue-800"
                    >
                      {{ rental.type }}
                    </span>
                  </div> -->
                </div>

                <!-- Status, Payment Chips (horizontal) and Date (below) -->
                <div class="mb-4">
                  <div class="flex flex-wrap items-center gap-2">
                    <span
                      v-if="Number(rental.isapproved) === 1"
                      class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-green-100 text-green-700"
                    >
                      <svg
                        class="w-3.5 h-3.5 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M5 13l4 4L19 7"
                        />
                      </svg>
                      Active
                    </span>
                    <span
                      v-else-if="Number(rental.isapproved) === 2"
                      class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-red-100 text-red-700"
                    >
                      <svg
                        class="w-3.5 h-3.5 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                      Rejected
                    </span>
                    <span
                      v-else
                      class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-yellow-100 text-yellow-700"
                    >
                      <svg
                        class="w-3.5 h-3.5 mr-1"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                      </svg>
                      Pending
                    </span>
                    <!-- Pay/Paid/Repay chips horizontally -->
                    <!-- <div class="flex items-center gap-2">
                      <button
                        v-if="!rental.bank_slip || rental.bank_slip === ''"
                        type="button"
                        @click="openPaymentModal(rental)"
                        class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 hover:bg-blue-200 transition-colors"
                      >
                        <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                        </svg>
                        ክፍያ ይፈጽሙ
                      </button>
                      <template v-else>
                        <span
                          class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-emerald-100 text-emerald-700"
                        >
                          <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                          </svg>
                          ተከፍሏል
                        </span>
                        <button
                          type="button"
                          @click="openPaymentModal(rental)"
                          class="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold bg-blue-100 text-blue-700 hover:bg-blue-200 transition-colors"
                        >
                          <svg class="w-3.5 h-3.5 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
                          </svg>
                          ደረሰኝ
                        </button>
                      </template>
                    </div> -->
                  </div>
                  <div class="mt-2 flex items-center text-xs text-gray-600">
                    <svg
                      class="w-4 h-4 mr-1.5"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                      />
                    </svg>
                    <span>{{ formatDate(rental.posted_date) }}</span>
                  </div>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
                  <div class="flex items-start space-x-3">
                    <div
                      class="flex-shrink-0 w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center"
                    >
                      <svg
                        class="w-4 h-4 text-green-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                        ></path>
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <p class="text-sm font-medium text-gray-500">አድራሻ</p>
                      <p class="text-gray-900 font-semibold">
                        {{ rental.address }}
                      </p>
                    </div>
                  </div>

                  <div class="flex items-start space-x-3">
                    <div
                      class="flex-shrink-0 w-8 h-8 bg-yellow-100 rounded-lg flex items-center justify-center"
                    >
                      <svg
                        class="w-4 h-4 text-yellow-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <p class="text-sm font-medium text-gray-500">ዋጋ</p>
                      <p class="text-gray-900 font-bold text-lg">
                        {{ rental.price }} ብር
                      </p>
                    </div>
                  </div>

                  <div class="flex items-start space-x-3">
                    <div
                      class="flex-shrink-0 w-8 h-8 bg-purple-100 rounded-lg flex items-center justify-center"
                    >
                      <svg
                        class="w-4 h-4 text-purple-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                        ></path>
                      </svg>
                    </div>
                    <div>
                      <p class="text-sm font-medium text-gray-500">ስልክ ቁጥር</p>
                      <p class="text-gray-900 font-semibold">
                        {{ rental.phone }}
                      </p>
                    </div>
                  </div>
                </div>

                <div v-if="rental.description" class="mb-6">
                  <h4 class="text-gray-900 font-bold text-lg mb-2">
                    <strong>ዝርዝር መግለጫ</strong>
                  </h4>
                  <p class="text-gray-700 leading-relaxed whitespace-pre-wrap">
                    {{
                      isExpanded[rental.rent_id]
                        ? rental.description.replace(/\\n/g, "\n")
                        : rental.description
                            .replace(/\\n/g, " ")
                            .slice(0, 160) +
                          (rental.description.length > 160 ? "…" : "")
                    }}
                  </p>
                  <button
                    v-if="rental.description && rental.description.length > 160"
                    @click="toggleExpand(rental.rent_id)"
                    type="button"
                    class="mt-2 text-blue-600 hover:text-blue-700 text-sm font-medium"
                  >
                    {{
                      isExpanded[rental.rent_id] ? "ያነሰ ይመልከቱ" : "ተጨማሪ ይመልከቱ"
                    }}
                  </button>
                </div>
              </div>

              <!-- Action Buttons -->
              <div class="px-6 pb-6">
                <div class="flex space-x-3">
                  <button
                    @click="openEditModal(rental)"
                    type="button"
                    class="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold py-2 px-3 rounded-lg shadow-md hover:from-blue-600 hover:to-blue-700 hover:shadow-lg transition-all duration-200 flex items-center justify-center space-x-1.5 group text-sm"
                  >
                    <svg
                      class="w-3.5 h-3.5 group-hover:scale-110 transition-transform duration-200"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                      ></path>
                    </svg>
                    <span>አስተካክል</span>
                  </button>
                  <button
                    @click="deleteRental(rental.rent_id)"
                    type="button"
                    class="flex-1 bg-gradient-to-r from-red-500 to-red-600 text-white font-semibold py-2 px-3 rounded-lg shadow-md hover:from-red-600 hover:to-red-700 hover:shadow-lg transition-all duration-200 flex items-center justify-center space-x-1.5 group text-sm"
                  >
                    <svg
                      class="w-3.5 h-3.5 group-hover:scale-110 transition-transform duration-200"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                      ></path>
                    </svg>
                    <span>አጥፋ</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Refresh Button -->
          <div class="flex justify-center mt-8">
            <button
              @click="fetchRentals"
              :disabled="loading"
              class="bg-gradient-to-r from-indigo-500 to-purple-600 text-white font-semibold py-3 px-6 rounded-xl shadow-lg hover:from-indigo-600 hover:to-purple-700 hover:shadow-xl transition-all duration-200 flex items-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              <svg
                v-if="loading"
                class="w-5 h-5 animate-spin"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                ></path>
              </svg>
              <svg
                v-else
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                ></path>
              </svg>
              <span>{{ loading ? "Loading..." : "Refresh" }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Edit Modal -->
    <transition name="modal-drop">
      <div
        v-if="showEditModal"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      >
        <div
          class="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-y-auto"
        >
          <!-- Enhanced Modal Header -->
          <div
            class="bg-gradient-to-r from-blue-500 via-purple-600 to-indigo-600 px-8 py-6 rounded-t-2xl"
          >
            <div class="flex justify-between items-center">
              <div class="flex items-center space-x-3">
                <div
                  class="w-10 h-10 bg-white bg-opacity-20 rounded-xl flex items-center justify-center"
                >
                  <svg
                    class="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"
                    ></path>
                  </svg>
                </div>
                <div>
                  <h3 class="text-2xl font-bold text-white">
                    የኪራይ ንብረትዎን ያስተካክሉ
                  </h3>
                  <p class="text-blue-100 text-sm">
                    የእርስዎን የኪራይ ንብረት ዝርዝሮች ያስተካክሉ
                  </p>
                </div>
              </div>
              <button
                @click="closeEditModal"
                class="w-10 h-10 bg-white bg-opacity-20 rounded-xl flex items-center justify-center text-white hover:bg-opacity-30 transition-all duration-200 group"
              >
                <svg
                  class="w-5 h-5 group-hover:scale-110 transition-transform duration-200"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </button>
            </div>
          </div>

          <!-- Enhanced Modal Content -->
          <div class="p-8">
            <form @submit.prevent="updateRental" class="space-y-8">
              <!-- Basic Information Section -->
              <div class="space-y-4">
                <div class="flex items-center space-x-3 mb-6">
                  <div
                    class="w-8 h-8 bg-gradient-to-r from-blue-500 to-blue-600 rounded-xl flex items-center justify-center"
                  >
                    <svg
                      class="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                      ></path>
                    </svg>
                  </div>
                  <h3 class="text-xl font-bold text-gray-900">መሰረታዊ መረጃ</h3>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <!-- Title -->
                  <div class="space-y-1">
                    <label class="block text-sm font-medium text-gray-700"
                      >Item Title | መጠርያ ስም
                      <span class="text-red-500">*</span></label
                    >
                    <input
                      v-model="editForm.title"
                      type="text"
                      placeholder="ገላጭ ርዕስ ያስገቡ(ለምሳሌ የሚከራይ ቤት)"
                      class="w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 border-gray-300 hover:border-gray-400"
                    />
                  </div>

                  <!-- Type -->
                  <!-- <div class="space-y-1">
                    <label class="block text-sm font-medium text-gray-700"
                      >Item Type | ዓይነት
                      <span class="text-red-500">*</span></label
                    >
                    <input
                      v-model="editForm.type"
                      type="text"
                      placeholder="ዓይነት (አፓርታማ፣ኮንደሚኒየም፣ግቢ ወዘተ)"
                      class="w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 border-gray-300 hover:border-gray-400"
                    />
                  </div> -->

                  <!-- Price -->
                  <div class="space-y-1">
                    <label class="block text-sm font-medium text-gray-700">
                      Price | ዋጋ <span class="text-red-500">*</span></label
                    >
                    <div class="relative">
                      <div
                        class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      >
                        <span class="text-gray-500 text-sm">$</span>
                      </div>
                      <input
                        v-model.number="editForm.price"
                        type="number"
                        min="0"
                        step="0.01"
                        placeholder="0.00"
                        class="w-full pl-7 pr-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 border-gray-300 hover:border-gray-400"
                      />
                    </div>
                  </div>

                  <!-- Phone -->
                  <div class="space-y-1">
                    <label class="block text-sm font-medium text-gray-700"
                      >Contact Phone | ስልክ ቁጥር
                      <span class="text-red-500">*</span></label
                    >
                    <input
                      v-model="editForm.phone"
                      type="tel"
                      placeholder="ስልክ ቁጥር ያስገቡ"
                      class="w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 border-gray-300 hover:border-gray-400"
                    />
                  </div>
                </div>

                <!-- Address -->
                <div class="space-y-1">
                  <label class="block text-sm font-medium text-gray-700"
                    >Location | አድራሻ <span class="text-red-500">*</span></label
                  >
                  <input
                    v-model="editForm.address"
                    type="text"
                    placeholder="አድራሻ ያስገቡ"
                    class="w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 border-gray-300 hover:border-gray-400"
                  />
                </div>

                <!-- Description -->
                <div class="space-y-1">
                  <label class="block text-sm font-medium text-gray-700"
                    >Description | ዝርዝር መግለጫ
                    <span class="text-red-500">*</span></label
                  >
                  <textarea
                    v-model="editForm.description"
                    rows="3"
                    placeholder="ማንኛውንም አስፈላጊ ዝርዝሮችን ይግለጹ..."
                    class="w-full px-3 py-2 border rounded-lg text-gray-900 placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 resize-none border-gray-300 hover:border-gray-400"
                  ></textarea>
                </div>
              </div>

              <!-- Media Section -->
              <div class="space-y-4">
                <div class="flex items-center space-x-3 mb-6">
                  <div
                    class="w-8 h-8 bg-gradient-to-r from-green-500 to-green-600 rounded-xl flex items-center justify-center"
                  >
                    <svg
                      class="w-4 h-4 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                      ></path>
                    </svg>
                  </div>
                  <h3 class="text-xl font-bold text-gray-900">ቪዲዮ እና ፎቶ</h3>
                </div>

                <!-- Images Upload -->
                <div class="space-y-3">
                  <div class="flex items-center justify-between">
                    <label class="block text-sm font-medium text-gray-700"
                      >የንብረቱ ፎቶ <span class="text-red-500">*</span></label
                    >
                    <span class="text-xs text-gray-500"
                      >እስከ 10 ፎቶዎችን ይጨምሩ።</span
                    >
                  </div>
                  <input
                    ref="editImageInput"
                    type="file"
                    @change="handleEditImages"
                    accept="image/*"
                    multiple
                    class="hidden"
                  />

                  <!-- Horizontal Scrolling Container for Images -->
                  <div class="overflow-x-auto pb-2">
                    <div class="flex space-x-3 min-w-max">
                      <!-- Current Image Previews -->
                      <div
                        v-for="(img, idx) in editForm.currentImages"
                        :key="'current-' + idx"
                        class="relative group flex-shrink-0 w-32 h-20 rounded-lg overflow-hidden border-2 border-gray-200 hover:border-blue-300 transition-all duration-200"
                      >
                        <img
                          :src="img"
                          class="w-full h-full object-contain bg-gray-50"
                        />
                        <div
                          class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center"
                        >
                          <div
                            class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1"
                          >
                            <button
                              type="button"
                              @click="removeCurrentImage(idx)"
                              class="p-1.5 bg-red-500 bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                            >
                              <svg
                                class="w-3 h-3 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M6 18L18 6M6 6l12 12"
                                ></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- New Image Previews -->
                      <div
                        v-for="(img, idx) in editForm.newImages"
                        :key="'new-' + idx"
                        class="relative group flex-shrink-0 w-32 h-20 rounded-lg overflow-hidden border-2 border-gray-200 hover:border-blue-300 transition-all duration-200"
                      >
                        <img
                          :src="img"
                          class="w-full h-full object-contain bg-gray-50"
                        />
                        <div
                          class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center"
                        >
                          <div
                            class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1"
                          >
                            <button
                              type="button"
                              @click="replaceEditImage(idx)"
                              class="p-1.5 bg-white bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                            >
                              <svg
                                class="w-3 h-3 text-gray-700"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                ></path>
                              </svg>
                            </button>
                            <button
                              type="button"
                              @click="removeNewImage(idx)"
                              class="p-1.5 bg-red-500 bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                            >
                              <svg
                                class="w-3 h-3 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M6 18L18 6M6 6l12 12"
                                ></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- Add Image Button -->
                      <div
                        v-if="
                          editForm.currentImages.length +
                            editForm.newImages.length <
                          10
                        "
                        class="flex-shrink-0 w-32 h-20 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all duration-200 group"
                        @click="triggerEditImageFile"
                      >
                        <svg
                          class="w-6 h-6 text-gray-400 group-hover:text-blue-500 transition-colors duration-200"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                          ></path>
                        </svg>
                        <span
                          class="text-xs text-gray-500 group-hover:text-blue-600 mt-1 text-center"
                          >ፎቶ</span
                        >
                      </div>
                    </div>
                  </div>

                  <!-- Image Validation Message -->
                  <!-- <p
                    v-if="!hasRequiredImages"
                    class="text-red-600 text-xs flex items-center space-x-1"
                  >
                    <svg
                      class="w-4 h-4"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                        clip-rule="evenodd"
                      ></path>
                    </svg>
                    <span>ቢያንስ 1 ፎቶ ያስፈልጋል</span>
                  </p> -->
                </div>

                <!-- Videos Upload (Optional) -->
                <div class="space-y-3">
                  <div class="flex items-center justify-between">
                    <label class="block text-sm font-medium text-gray-700">
                      አጭር ቪዲዮ (መተው ይቻላል)</label
                    >
                    <span class="text-xs text-gray-500">እስከ 30 ሴኮንድ</span>
                  </div>
                  <input
                    ref="editVideoInput"
                    type="file"
                    @change="handleEditVideos"
                    accept="video/*"
                    multiple
                    class="hidden"
                  />

                  <!-- Horizontal Scrolling Container for Videos -->
                  <div class="overflow-x-auto pb-2">
                    <div class="flex space-x-3 min-w-max">
                      <!-- Current Video Previews -->
                      <div
                        v-for="(vid, idx) in editForm.currentVideos"
                        :key="'current-vid-' + idx"
                        class="relative group flex-shrink-0 w-32 h-20 rounded-lg overflow-hidden border-2 border-gray-200 hover:border-blue-300 transition-all duration-200"
                      >
                        <video
                          :src="vid"
                          class="w-full h-full object-contain bg-gray-50"
                          controls
                        ></video>
                        <div
                          class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center"
                        >
                          <div
                            class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1"
                          >
                            <button
                              type="button"
                              @click="removeCurrentVideo(idx)"
                              class="p-1.5 bg-red-500 bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                            >
                              <svg
                                class="w-3 h-3 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M6 18L18 6M6 6l12 12"
                                ></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- New Video Previews -->
                      <div
                        v-for="(vid, idx) in editForm.newVideos"
                        :key="'new-vid-' + idx"
                        class="relative group flex-shrink-0 w-32 h-20 rounded-lg overflow-hidden border-2 border-gray-200 hover:border-blue-300 transition-all duration-200"
                      >
                        <video
                          :src="vid"
                          class="w-full h-full object-contain bg-gray-50"
                          controls
                        ></video>
                        <div
                          class="absolute inset-0 bg-black bg-opacity-0 group-hover:bg-opacity-30 transition-all duration-200 flex items-center justify-center"
                        >
                          <div
                            class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex space-x-1"
                          >
                            <button
                              type="button"
                              @click="replaceEditVideo(idx)"
                              class="p-1.5 bg-white bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                            >
                              <svg
                                class="w-3 h-3 text-gray-700"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                                ></path>
                              </svg>
                            </button>
                            <button
                              type="button"
                              @click="removeNewVideo(idx)"
                              class="p-1.5 bg-red-500 bg-opacity-90 rounded-full hover:bg-opacity-100 transition-all duration-200"
                            >
                              <svg
                                class="w-3 h-3 text-white"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M6 18L18 6M6 6l12 12"
                                ></path>
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>

                      <!-- Add Video Button -->
                      <div
                        v-if="
                          editForm.currentVideos.length +
                            editForm.newVideos.length <
                          3
                        "
                        class="flex-shrink-0 w-32 h-20 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-blue-400 hover:bg-blue-50 transition-all duration-200 group"
                        @click="triggerEditVideoFile"
                      >
                        <svg
                          class="w-6 h-6 text-gray-400 group-hover:text-blue-500 transition-colors duration-200"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
                          ></path>
                        </svg>
                        <span
                          class="text-xs text-gray-500 group-hover:text-blue-600 mt-1 text-center"
                          >ቪድዮ</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Modal Actions -->
              <div class="pt-4 border-t border-gray-200">
                <div class="flex flex-col sm:flex-row gap-3">
                  <button
                    type="button"
                    @click="closeEditModal"
                    class="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-all duration-200 text-sm"
                  >
                    ዝጋ
                  </button>
                  <button
                    type="submit"
                    :disabled="isUpdating || !isFormValid"
                    class="flex-1 bg-gradient-to-r from-blue-500 to-purple-600 text-white font-semibold py-2.5 px-4 rounded-lg shadow-lg hover:from-blue-600 hover:to-purple-700 hover:shadow-xl transition-all duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
                  >
                    <svg
                      v-if="isUpdating"
                      class="w-4 h-4 animate-spin"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                      ></path>
                    </svg>
                    <svg
                      v-else
                      class="w-4 h-4"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7"
                      ></path>
                    </svg>
                    <span>{{ isUpdating ? "በማስተካከል ላይ..." : "አስተካክል" }}</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </transition>

    <!-- Payment Modal -->
    <transition name="modal-drop">
      <div
        v-if="showPaymentModal"
        class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
      >
        <div
          ref="paymentModal"
          class="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] overflow-y-auto"
        >
          <div
            class="bg-gradient-to-r from-blue-500 to-purple-600 px-8 py-6 rounded-t-2xl"
          >
            <div class="flex justify-between items-center">
              <div class="flex items-center space-x-3">
                <div
                  class="w-10 h-10 bg-white bg-opacity-20 rounded-xl flex items-center justify-center"
                >
                  <svg
                    class="w-6 h-6 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1"
                    />
                  </svg>
                </div>
                <div>
                  <h3 class="text-2xl font-bold text-white">እባክዎ ክፍያ ያጠናቅቁ</h3>
                  <p class="text-blue-100 text-sm">
                    የመክፈያ ዘዴ ይምረጡ፣ ይክፈሉ፣ ከዚያ ደረሰኝዎን ይላኩ።
                  </p>
                </div>
              </div>
              <button
                @click="closePaymentModal"
                class="w-10 h-10 bg-white bg-opacity-20 rounded-xl flex items-center justify-center text-white hover:bg-opacity-30 transition-all duration-200 group"
              >
                <svg
                  class="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>
          </div>

          <div class="p-8 space-y-8">
            <!-- Rental Title -->
            <div
              v-if="paymentRentalTitle"
              class="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"
            >
              <p class="text-xs text-gray-500">Paying for</p>
              <h4 class="text-gray-900 font-bold text-lg leading-snug">
                {{ paymentRentalTitle }}
              </h4>
            </div>
            <!-- Accounts -->
            <div>
              <h4 class="text-gray-900 font-bold mb-3">የመክፈያ ዘዴ ይምረጡ</h4>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div
                  v-for="m in paymentMethods"
                  :key="m.id"
                  class="rounded-xl p-4 cursor-pointer transition-all duration-200 hover:shadow-sm"
                  :class="
                    paymentForm.selectedMethod === m.id
                      ? m.selectedClass
                      : m.baseClass
                  "
                  @click="selectAndCopy(m.id, m.value)"
                >
                  <div class="flex items-start justify-between">
                    <div class="flex items-start space-x-3">
                      <img
                        :src="m.logo"
                        :alt="m.name"
                        class="w-8 h-8 object-contain"
                      />
                      <div>
                        <p
                          class="text-sm font-semibold"
                          :class="m.nameTextClass"
                        >
                          {{ m.name }}
                        </p>
                        <p class="text-gray-900 font-bold text-lg">
                          {{ m.value }}
                        </p>
                        <p class="text-xs text-gray-600">
                          ስም: {{ m.accountName }}
                        </p>
                      </div>
                    </div>
                    <button
                      type="button"
                      class="text-xs font-semibold"
                      :class="m.copyTextClass"
                      @click.stop="selectAndCopy(m.id, m.value)"
                    >
                      Copy
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Steps -->
            <div class="bg-gray-50 rounded-xl p-4">
              <h4 class="text-gray-900 font-bold mb-2">እንዴት መክፈል ይቻላል?</h4>
              <ol class="list-decimal ml-5 text-sm text-gray-700 space-y-1">
                <li>ከላይ ካሉት የመክፈያ ዘዴዎች ወደ አንዱ 200 ብር ያስተላልፉ።</li>
                <li>ደረሰኙ ግልጽ የሆነ ፎቶ ወይም ስክሪንሹት ያንሱት።</li>
                <li>ከዛ ከዚ በታች ባለው ሳጥን ፎቶውን ይላኩት።</li>
              </ol>
            </div>

            <!-- Upload -->
            <div class="space-y-3">
              <label class="block text-sm font-medium text-gray-700"
                >የከፈሉበት ደረሰኝ ያስገቡ</label
              >
              <input
                ref="receiptInput"
                type="file"
                accept="image/*"
                class="hidden"
                @change="handleReceipt"
              />
              <div>
                <div
                  v-if="!paymentForm.receiptPreview"
                  class="w-full h-44 md:h-60 border-2 border-dashed rounded-lg flex flex-col items-center justify-center transition-all duration-200 group border-gray-300 hover:border-emerald-400 hover:bg-emerald-50 cursor-pointer"
                  @click="triggerReceiptFile"
                >
                  <svg
                    class="w-8 h-8 text-gray-400 group-hover:text-emerald-500 transition-colors duration-200"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                    />
                  </svg>
                  <span
                    class="text-sm text-gray-500 group-hover:text-emerald-600 mt-2"
                    >የደረሰኙ ፎቶ ያስገቡ</span
                  >
                </div>
                <div
                  v-else
                  class="w-full h-44 md:h-60 rounded-lg overflow-hidden border-2 border-gray-200 cursor-pointer"
                  @click="triggerReceiptFile"
                >
                  <img
                    :src="paymentForm.receiptPreview"
                    class="w-full h-full object-cover"
                  />
                </div>
              </div>
              <p v-if="paymentError" class="text-xs text-red-600">
                {{ paymentError }}
              </p>
            </div>

            <!-- Actions -->
            <div class="pt-2 border-t border-gray-200 flex gap-3">
              <button
                type="button"
                @click="closePaymentModal"
                class="flex-1 px-4 py-2.5 border border-gray-300 text-gray-700 font-medium rounded-lg hover:bg-gray-50 transition-all duration-200 text-sm"
              >
                ዝጋ
              </button>
              <button
                type="button"
                :disabled="isPaySubmitting || !paymentForm.receiptFile"
                @click="submitReceipt"
                class="flex-1 bg-gradient-to-r from-emerald-500 to-teal-600 text-white font-semibold py-2.5 px-4 rounded-lg shadow-lg hover:from-emerald-600 hover:to-teal-700 hover:shadow-xl transition-all duration-200 flex items-center justify-center space-x-2 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
              >
                <svg
                  v-if="isPaySubmitting"
                  class="w-4 h-4 animate-spin"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
                  />
                </svg>
                <span>{{ isPaySubmitting ? "እየላከ ነው..." : "ደረሰኙ ይላኩ" }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { apolloClient } from "@/apollo"; // your Apollo client instance
import { gql } from "@apollo/client/core";
import axios from "axios";
import { toast } from "@/toast";

export default {
  data() {
    return {
      rentals: [],
      loading: false,
      error: null,
      isExpanded: {},
      showEditModal: false,
      isUpdating: false,
      editForm: {
        rent_id: "",
        title: "",
        address: "",
        price: "",
        phone: "",
        description: "",
        // type: "",
        currentImages: [],
        newImages: [],
        newImageFiles: [],
        currentVideos: [],
        newVideos: [],
        newVideoFiles: [],
      },
      editImageInput: null,
      editVideoInput: null,
      replaceImageIndex: null,
      replaceVideoIndex: null,
      domainUrl: "https://bdr.desalegntentprduction.com",
      // Payment modal state
      showPaymentModal: false,
      isPaySubmitting: false,
      paymentError: "",
      paymentForm: {
        rent_id: "",
        receiptFile: null,
        receiptPreview: "",
        selectedMethod: "",
      },

      // Payment methods configuration
      paymentMethods: [
        {
          id: "cbe",
          name: "CBE",
          value: "1000184010252",
          logo: require("@/assets/cbe.png"),
          accountName: "ወንድም ወርቁ",
          nameTextClass: "text-blue-700",
          baseClass: "border border-blue-100 bg-blue-50",
          selectedClass: "border-2 border-blue-500 bg-blue-50 shadow",
          copyTextClass: "text-blue-600 hover:text-blue-700",
        },
        {
          id: "boa",
          name: "Bank of Abyssinia",
          value: "116971267",
          logo: require("@/assets/boa.png"),
          accountName: "ወንድም ወርቁ",
          nameTextClass: "text-purple-700",
          baseClass: "border border-purple-100 bg-purple-50",
          selectedClass: "border-2 border-purple-500 bg-purple-50 shadow",
          copyTextClass: "text-purple-700 hover:text-purple-800",
        },
        {
          id: "telebirr",
          name: "TeleBirr",
          value: "0912473927",
          logo: require("@/assets/telebirr.png"),
          accountName: "ወንድም ወርቁ",
          nameTextClass: "text-yellow-700",
          baseClass: "border border-yellow-100 bg-yellow-50",
          selectedClass: "border-2 border-yellow-500 bg-yellow-50 shadow",
          copyTextClass: "text-yellow-700 hover:text-yellow-800",
        },
      ],
    };
  },

  computed: {
    // Check if form has at least 1 image
    // hasRequiredImages() {
    //   return (
    //     this.editForm.currentImages.length + this.editForm.newImages.length > 0
    //   );
    // },

    // Check if form is valid for submission
    isFormValid() {
      return (
        // this.hasRequiredImages &&
        this.editForm.title.trim() &&
        this.editForm.address.trim() &&
        this.editForm.price &&
        this.editForm.phone.trim()
      );
    },

    paymentRentalTitle() {
      const id = this.paymentForm && this.paymentForm.rent_id;
      if (!id) return "";
      const r = this.rentals.find((x) => x.rent_id === id);
      return r && r.title ? r.title : "";
    },
  },

  methods: {
    toggleExpand(id) {
      this.$set
        ? this.$set(this.isExpanded, id, !this.isExpanded[id])
        : (this.isExpanded = {
            ...this.isExpanded,
            [id]: !this.isExpanded[id],
          });
    },

    formatDate(input) {
      if (!input) return "-";

      let date;
      // If it's a number or numeric string, treat as UNIX timestamp
      if (
        typeof input === "number" ||
        (typeof input === "string" && /^\d+$/.test(input))
      ) {
        const num = Number(input);
        // If seconds (10 digits), convert to ms
        const ms = String(num).length === 10 ? num * 1000 : num;
        date = new Date(ms);
      } else {
        // Try to parse ISO/MySQL datetime string
        const parsed = Date.parse(input);
        date = isNaN(parsed) ? null : new Date(parsed);
      }

      if (!date || isNaN(date.getTime())) return "-";

      const pad = (n) => String(n).padStart(2, "0");
      const yyyy = String(date.getFullYear());
      const mm = pad(date.getMonth() + 1);
      const dd = pad(date.getDate());
      const hh = pad(date.getHours());
      const min = pad(date.getMinutes());
      const ss = pad(date.getSeconds());
      return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
    },

    async fetchRentals() {
      this.loading = true;
      this.error = null;

      const GET_RENTALS = gql`
        query GetRentals($user_id: String!) {
          rentalsByUser(user_id: $user_id) {
            rent_id
            title
            address
            price
            phone
            description

            images
            videos
            isapproved
            posted_date
            message_id
            bank_slip
            user_id
          }
        }
      `;

      try {
        const result = await apolloClient.query({
          query: GET_RENTALS, // Your gql query
          variables: { user_id: this.$store.getters.userId }, // Pass the user_id string from store
          fetchPolicy: "no-cache", // Optional, ensures fresh data
        });

        this.rentals = result.data.rentalsByUser;

        // Auto-open payment modal if any rental missing bank_slip
        const missing = this.rentals.find(
          (r) => !r.bank_slip || r.bank_slip === ""
        );
        if (missing && !this.showPaymentModal) {
          // this.openPaymentModal(missing);
        }
      } catch (err) {
        console.log(err);

        toast.error(err.message || "ምንም ውጤት አልተገኘም። እባክዎን እንደገና ይሞክሩ");
      } finally {
        this.loading = false;
      }
    },

    async deleteRental(rent_id) {
      const confirmDelete = confirm("እርግጠኛ ነዎት ይህን ኪራይ መሰረዝ ይፈልጋሉ?");
      if (!confirmDelete) return;

      const DELETE_RENTAL = gql`
        mutation DeleteRental($rent_id: ID!) {
          deleteRental(rent_id: $rent_id)
        }
      `;

      try {
        const result = await apolloClient.mutate({
          mutation: DELETE_RENTAL,
          variables: { rent_id },
        });

        if (result.data.deleteRental) {
          // ✅ Remove from local list without re-fetching
          toast.success("ኪራይ በተሳካ ሁኔታ ተሰርዟል።");
          this.rentals = this.rentals.filter((r) => r.rent_id !== rent_id);
        } else {
          toast.error("ኪራይ መሰረዝ አልተሳካም።");
        }
      } catch (err) {
        toast.error(err.message || "ኪራይ መሰረዝ አልተሳካም። እባክዎን እንደገና ይሞክሩ");
      } finally {
        this.loading = false;
      }
    },

    openEditModal(rental) {
      this.editForm = {
        rent_id: rental.rent_id,
        title: rental.title,
        address: rental.address,
        price: rental.price,
        phone: rental.phone,
        description: rental.description.replace(/\\n/g, "\n"),

        user_id: rental.user_id, // Add user_id to edit form
        currentImages: rental.images
          ? rental.images.split(",").filter((img) => img && img.trim() !== "")
          : [],
        newImages: [],
        newImageFiles: [],
        currentVideos: rental.videos
          ? rental.videos.split(",").filter((vid) => vid && vid.trim() !== "")
          : [],
        newVideos: [],
        newVideoFiles: [],
      };
      this.showEditModal = true;
    },

    closeEditModal() {
      this.showEditModal = false;
      this.editForm = {
        rent_id: "",
        title: "",
        address: "",
        price: "",
        phone: "",
        description: "",

        currentImages: [],
        newImages: [],
        newImageFiles: [],
        currentVideos: [],
        newVideos: [],
        newVideoFiles: [],
      };
    },

    // Image and Video handling functions (copied from homePage.vue)
    triggerEditImageFile() {
      this.$refs.editImageInput.click();
    },

    triggerEditVideoFile() {
      this.$refs.editVideoInput.click();
    },

    handleEditImages(e) {
      const files = Array.from(e.target.files);
      if (this.replaceImageIndex !== null) {
        const idx = this.replaceImageIndex;
        this.editForm.newImageFiles[idx] = files[0];
        const r = new FileReader();
        r.onload = (ev) => (this.editForm.newImages[idx] = ev.target.result);
        r.readAsDataURL(files[0]);
        this.replaceImageIndex = null;
      } else {
        files.forEach((f) => {
          this.editForm.newImageFiles.push(f);
          const r = new FileReader();
          r.onload = (ev) => this.editForm.newImages.push(ev.target.result);
          r.readAsDataURL(f);
        });
      }
    },

    replaceEditImage(idx) {
      this.replaceImageIndex = idx;
      this.triggerEditImageFile();
    },

    removeCurrentImage(idx) {
      this.editForm.currentImages.splice(idx, 1);
    },

    removeNewImage(idx) {
      this.editForm.newImages.splice(idx, 1);
      this.editForm.newImageFiles.splice(idx, 1);
    },

    handleEditVideos(e) {
      const files = Array.from(e.target.files);
      if (this.replaceVideoIndex !== null) {
        const idx = this.replaceVideoIndex;
        this.editForm.newVideoFiles[idx] = files[0];
        const r = new FileReader();
        r.onload = (ev) => (this.editForm.newVideos[idx] = ev.target.result);
        r.readAsDataURL(files[0]);
        this.replaceVideoIndex = null;
      } else {
        files.forEach((f) => {
          this.editForm.newVideoFiles.push(f);
          const r = new FileReader();
          r.onload = (ev) => this.editForm.newVideos.push(ev.target.result);
          r.readAsDataURL(f);
        });
      }
    },

    replaceEditVideo(idx) {
      this.replaceVideoIndex = idx;
      this.triggerEditVideoFile();
    },

    removeCurrentVideo(idx) {
      this.editForm.currentVideos.splice(idx, 1);
    },

    removeNewVideo(idx) {
      this.editForm.newVideos.splice(idx, 1);
      this.editForm.newVideoFiles.splice(idx, 1);
    },

    // Upload function for backend endpoint (copied from homePage.vue)
    async uploadImage(fileToUpload) {
      const formData = new FormData();
      formData.append("file", fileToUpload);

      try {
        const response = await axios.post(
          `${this.domainUrl}/upload`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        return this.domainUrl + response.data.filePath;
      } catch (error) {
        console.error("Error uploading file:", error);
        throw error;
      }
    },

    async updateRental() {
      this.isUpdating = true;

      try {
        // Upload new images to backend
        let cloudinaryImageUrls = [];
        for (let i = 0; i < this.editForm.newImageFiles.length; i++) {
          const uploadedUrl = await this.uploadImage(
            this.editForm.newImageFiles[i]
          );
          cloudinaryImageUrls.push(uploadedUrl);
        }

        // Upload new videos to backend
        let cloudinaryVideoUrls = [];
        for (let i = 0; i < this.editForm.newVideoFiles.length; i++) {
          const uploadedUrl = await this.uploadImage(
            this.editForm.newVideoFiles[i]
          );
          cloudinaryVideoUrls.push(uploadedUrl);
        }

        // Combine current and new media URLs
        const allImages = [
          ...this.editForm.currentImages,
          ...cloudinaryImageUrls,
        ];
        const allVideos = [
          ...this.editForm.currentVideos,
          ...cloudinaryVideoUrls,
        ];

        // Validation: At least 1 image is required
        // if (allImages.length === 0) {
        //   toast.error("At least 1 image is required");
        //   this.isUpdating = false;
        //   return;
        // }

        const imagesString = allImages.join(",");
        const videosString = allVideos.join(",");

        const UPDATE_RENTAL = gql`
          mutation UpdateRental($rent_id: ID!, $input: RentalInput!) {
            updateRental(rent_id: $rent_id, input: $input) {
              rent_id
              title
              address
              price
              phone
              description

              images
              videos
              isapproved
            }
          }
        `;

        // Prepare input data with proper validation
        const inputData = {
          title: this.editForm.title || "",
          address: this.editForm.address || "",
          price: parseFloat(this.editForm.price) || 0,
          phone: this.editForm.phone || "",
          description:
            this.editForm.description.toString().trim().replace(/\n/g, "\\n") ||
            "",

          images: imagesString || "",
          videos: videosString || "",
          user_id: this.editForm.user_id || "",
          isapproved: 0, // Add required user_id field
        };

        console.log("Sending update request:", {
          rent_id: this.editForm.rent_id,
          input: inputData,
        });

        const result = await apolloClient.mutate({
          mutation: UPDATE_RENTAL,
          variables: {
            rent_id: this.editForm.rent_id,
            input: inputData,
          },
        });

        if (result.data.updateRental) {
          // Update the local rentals array with the response data
          const index = this.rentals.findIndex(
            (r) => r.rent_id === this.editForm.rent_id
          );
          if (index !== -1) {
            // The backend returns { rent_id, ...input }, so we use the response directly
            this.rentals[index] = result.data.updateRental;
          }

          toast.success("ኪራይ በተሳካ ሁኔታ ተስተካክሏል");
          this.closeEditModal();
        } else {
          toast.error("ኪራይ ማስተካከል አልተሳካም");
        }
      } catch (err) {
        console.error("Error updating rental:", err);
        toast.error("ኪራይ ማስተካከል አልተሳካም፡ " + err.message);

        // Log detailed error information
        if (err.graphQLErrors) {
          console.error("GraphQL Errors:", err.graphQLErrors);
          toast.error("GraphQL Errors: " + err.graphQLErrors);
          err.graphQLErrors.forEach((error) => {
            console.error("GraphQL Error:", error.message);
            toast.error("GraphQL Error: " + error.message);
          });
        }

        if (err.networkError) {
          console.error("Network Error:", err.networkError);
          toast.error("Network Error: " + err.networkError);
        }

        // Show more detailed error message
        const errorMessage =
          err.graphQLErrors?.[0]?.message ||
          err.networkError?.message ||
          err.message ||
          "Error updating rental";

        toast.error(`ማስተካከል አልተሳካም፡ ${errorMessage}`);
      } finally {
        this.isUpdating = false;
      }
    },
    async copyText(value) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(value);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = value;
          textarea.style.position = "fixed";
          textarea.style.left = "-9999px";
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        toast.success("Copied to clipboard");
      } catch (e) {
        console.error(e);
        toast.error("Copy failed");
      }
    },

    // Payment modal handlers
    openPaymentModal(rental) {
      this.paymentError = "";
      this.paymentForm = {
        rent_id: rental.rent_id,
        receiptFile: null,
        receiptPreview: rental.bank_slip || "",
        selectedMethod: "",
      };
      this.showPaymentModal = true;
    },
    closePaymentModal() {
      this.showPaymentModal = false;
      this.paymentForm = { rent_id: "", receiptFile: null, receiptPreview: "" };
    },
    triggerReceiptFile() {
      this.$refs.receiptInput.click();
    },
    selectAndCopy(method, value) {
      this.paymentForm.selectedMethod = method;
      this.copyText(value);
      // Smooth scroll to bottom of payment modal after selection & copy
      this.$nextTick(() => {
        const el = this.$refs.paymentModal;
        if (el && typeof el.scrollTo === "function") {
          el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
        }
      });
    },
    handleReceipt(e) {
      const file = e.target.files && e.target.files[0];
      if (!file) return;
      if (!file.type.startsWith("image/")) {
        this.paymentError = "Please select an image file";
        return;
      }
      this.paymentError = "";
      this.paymentForm.receiptFile = file;
      const r = new FileReader();
      r.onload = (ev) => (this.paymentForm.receiptPreview = ev.target.result);
      r.readAsDataURL(file);
    },
    async submitReceipt() {
      if (!this.paymentForm.receiptFile) {
        this.paymentError = "Receipt image is required";
        return;
      }
      this.isPaySubmitting = true;
      try {
        // Upload to backend
        const uploadedUrl = await this.uploadImage(
          this.paymentForm.receiptFile
        );

        // Save bank_slip path via GraphQL
        const UPDATE_RENTAL_BANK = gql`
          mutation UpdateRental($rent_id: ID!, $input: RentalInput!) {
            updateRental(rent_id: $rent_id, input: $input) {
              rent_id
              bank_slip
            }
          }
        `;

        const inputData = {
          // Minimal required fields (use existing item values from list)
          title: "",
          address: "",
          price: 0,
          phone: "",
          description: "",
          images: "",
          videos: "",
          user_id: this.$store.getters.userId,
          isapproved: 0,
          bank_slip: uploadedUrl,
        };

        // Fetch existing rental to fill required fields correctly
        const existing = this.rentals.find(
          (r) => r.rent_id === this.paymentForm.rent_id
        );
        if (existing) {
          inputData.title = existing.title || "";
          inputData.address = existing.address || "";
          inputData.price = parseFloat(existing.price) || 0;
          inputData.phone = existing.phone || "";
          inputData.description = (existing.description || "").toString();
          inputData.images = existing.images || "";
          inputData.videos = existing.videos || "";
          inputData.user_id =
            existing.user_id || this.$store.getters.userId || "";
        }

        const result = await apolloClient.mutate({
          mutation: UPDATE_RENTAL_BANK,
          variables: { rent_id: this.paymentForm.rent_id, input: inputData },
        });

        if (result && result.data && result.data.updateRental) {
          // Update local list
          const idx = this.rentals.findIndex(
            (r) => r.rent_id === this.paymentForm.rent_id
          );
          if (idx !== -1) {
            this.$set
              ? this.$set(this.rentals[idx], "bank_slip", uploadedUrl)
              : (this.rentals[idx] = {
                  ...this.rentals[idx],
                  bank_slip: uploadedUrl,
                });
          }
          toast.success(
            "ደረሰኝ በተሳካ ሁኔታ ተልኳል። እባክዎን በ አድሚን በኩል እስኪረጋገጥ ትንሽ ይጠብቁ።"
          );
          this.closePaymentModal();
        } else {
          toast.error("Failed to save receipt");
        }
      } catch (e) {
        console.error(e);
        toast.error(e.message || "Upload failed");
      } finally {
        this.isPaySubmitting = false;
      }
    },
  },

  async mounted() {
    await this.fetchRentals();
  },
};
</script>
